import {Routes, RouterModule} from '@angular/router';
import {NotFoundComponent} from './pages/not-found/components';
import { LoginComponent } from "./pages/authentication/components";
import { 
  DerivacionesComponent, 
  InscribirseComponent, 
  ConfirmarUsuarioClaveComponent,
  MenuPrincipalComponent,
  PacientesComponent
} from './pages/socios/components';
import { TieneUsuarioYReproComponent } from './pages/socios/components';
import { authGuard } from './guards/auth.guard';

const mainRoutes: Routes = [
  {path: '404', component: NotFoundComponent},
  { path: 'login', component: LoginComponent },
  { path: 'inscribirse', component: InscribirseComponent },
  { path: 'tiene-usuario-repro', component: TieneUsuarioYReproComponent },
  
  { 
    path: 'derivaciones',
    component: DerivacionesComponent
  },
  
  { path: 'confirmar-usuario', component:  ConfirmarUsuarioClaveComponent},
  
  { 
    path: 'socios-menu-principal', 
    component: MenuPrincipalComponent,
    canActivate: [authGuard],
    data: { role: 'ROLE_ADMIN' }
  },

  { 
    path: 'pacientes' ,
    component: PacientesComponent,
    canActivate: [authGuard],
    data: { role: 'ROLE_ADMIN' }
  },

  {path: '**', redirectTo: '/404'}
]; 

export const appRouting = RouterModule.forRoot(mainRoutes);
